(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["casonda-value-props"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('casonda-benefits-slider')) {
    customElements.define('casonda-benefits-slider', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const { signal } = this.controller;
        const track = this.querySelector('.casonda-vp__inner');
        const slides = [...this.querySelectorAll('.casonda-vp__item')];
        const dots = [...this.querySelectorAll('.casonda-vp__dot')];
        if (!dots.length) return;
        this.querySelector('.casonda-vp__dots').hidden = false;
        const update = () => {
          const bounds = track.getBoundingClientRect();
          const center = bounds.left + bounds.width / 2;
          let active = 0;
          let nearest = Infinity;
          slides.forEach((slide, index) => {
            const rect = slide.getBoundingClientRect();
            const distance = Math.abs(rect.left + rect.width / 2 - center);
            if (distance < nearest) { nearest = distance; active = index; }
          });
          dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === active)));
        };
        dots.forEach((dot, index) => dot.addEventListener('click', () => {
          const rect = slides[index].getBoundingClientRect();
          const bounds = track.getBoundingClientRect();
          track.scrollTo({
            left: track.scrollLeft + rect.left + rect.width / 2 - bounds.left - bounds.width / 2,
            behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
          });
        }, { signal }));
        track.addEventListener('scroll', update, { passive: true, signal });
        window.addEventListener('resize', update, { signal });
        update();
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
